import React from 'react'
import { observer } from 'mobx-react'
import TotalBox from '../../../components/CaseDetailPrice/TotalBox'

const CaselessDetailPrice = ({ total }) => {
  return <TotalBox amount={total || 0} />
}

export default observer(CaselessDetailPrice)
